import { Component, Inject, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ObjectTypeInfo } from 't4core';
import { LocationUserInfo } from 't4core';
import { ProductType, Additive } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { OneWayAdmin } from '../../../OneWayAdmin/owadmin.module';

@Component({
    styleUrls: ['CreateAddonDialog.css'],
    selector: 'CreateAddonDialog',
    templateUrl: 'CreateAddonDialog.html',
})
export class CreateAddonDialog extends DialogBase {
    public addonToOverride: ObjectTypeInfo;
    public addonToSave: ObjectTypeInfo;
    public replacements: ObjectTypeInfo[] = [];
    public objectTypes: ObjectTypeInfo[];
    @ViewChild("tblContent") private tblContent: T4DatatableWidget;

    constructor(
        public dialogRef: MatDialogRef<CreateAddonDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { allAddons: ObjectTypeInfo[], inheritedAddons: ObjectTypeInfo[], editable: boolean, addonToChange: ObjectTypeInfo } 
    ) {
        super("CreateAddonDialog");
    }


    public async ngOnInit() {
        if (this.data.addonToChange) {
            this.addonToSave = this.data.addonToChange;

            if (this.addonToSave.ReplacementFor) {
                var rep = this.addonToSave.ReplacementFor.split(";");
                for (let r of rep) {
                    var type = this.data.allAddons.find(x => "" + x.Id == r);
                    if (type) this.replacements.push(type);
                }
            }

            for (let a of this.data.allAddons) {
                if ("" + a.Id == this.addonToSave.OverridesType) this.addonToOverride = a;
            }
        }
        else {
            this.addonToSave = new ObjectTypeInfo;
            this.addonToSave.VATPercentage = 0;
            this.addonToSave.UnlimitedRelations = true;
        }

        await this.getObjectTypes();

        if (this.addonToSave.UnlimitedRelations) {
            this.selectAllRelations(true);
        }
    }

    public async getObjectTypes() {
        this.objectTypes = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetTypes", { type: 0 });

        for (var i of this.objectTypes) {
            if (this.addonToSave.AdditiveTo && this.addonToSave.AdditiveTo.some(x => x.MainObjectId == i.Id))
                this.tblContent.selectRow(i);
        }
    }

    public toggleAddonAvailability(event) {
        this.addonToSave.IsHidden = !event.checked;
    }

    public async save() {

        var token = this.beginLoad("T4.Settings.SaveAddonDialog.msgCreating", "Saving addon", null);

        this.addonToSave.AdditiveTo = [];
        for (var type of this.tblContent.selectedRows) {
            var a: Additive = new Additive();
            a.MainObjectId = type.Id;
            this.addonToSave.AdditiveTo.push(a);
        }

      var success = await this.Api.post<boolean>("RentalObject/SaveAddon", this.addonToSave, { type: 2 });
        this.endLoad(token);
        if (success) {
            this.dialogRef.close(this.data.inheritedAddons);
        }
        else {
            alert("Failed, try again!");
        }
    }

    public async selectAllRelations(clear: boolean) {
        if (!clear) {
            for (var i of this.objectTypes) {
                this.tblContent.deselectRow(i);
            }
        }
        else {
            for (var i of this.objectTypes) {
                this.tblContent.selectRow(i);
            }
        }
    }

    public async setFromOverride(event) {
        if (this.addonToOverride && this.addonToOverride.Id == event.value.Id) return;

        this.addonToSave.OverridesType = "" + event.value.Id;

        var override = await this.UI.confirm("T4.Settings.CreateAddonDialog.titleLoadSettings", "Load settings", "T4.Settings.CreateAddonDialog.msgLoadSettings", "Do you want to load the settings from this addon?");
        if (override) this.addonToSave = await this.Api.get("RentalObject/GetTypeInfo", { objectType: event.value.Id });

    }

    public setReplacements(event) {

        this.addonToSave.ReplacementFor = "";
        for (let r of event.value) {
            if (r.Id) this.addonToSave.ReplacementFor = this.addonToSave.ReplacementFor + r.Id + ";";
        }
    }
}
